export default __webpack_public_path__ + "static/media/site-title.5adae762.svg";